import React from 'react';

import seta from "../../../../img/landing-page/seta.svg"

const LandingPageCollapse = ({ number, header, content } = props) => {
    const collapse = (number) => {
        let element = document.getElementsByClassName(`content-to-${number}`)[0]

        if(!element) return

        element.classList.value.includes('offers-landing-page-collapses__collapse__expanded')
            ? element.classList.remove('offers-landing-page-collapses__collapse__expanded')
            : element.classList.add('offers-landing-page-collapses__collapse__expanded')
    }

    return (
        <div className={`offers-landing-page-collapses__collapse content-to-${number}`}>
            <div onClick={() => collapse( number)} className="offers-landing-page-collapses__collapse__header">
                <div className="offers-landing-page-collapses__collapse__header--number">
                    {number < 10 ? `0${number}` : number}
                </div>
                <div className="offers-landing-page-collapses__collapse__header--text">
                    {header}
                </div>
                <div className="offers-landing-page-collapses__collapse__header--arrow">
                    <img alt="" src={seta} />
                </div>
            </div>
            <div className="offers-landing-page-collapses__collapse__content">
                <div>
                    {content}
                </div>
            </div>
        </div>
    );
};

export default LandingPageCollapse;